
// Finally, add a <MyForm/> element whereever you wish to display the form.

import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import MyForm from "./myform";


const IndexPage = () => (
  <Layout2>
     <SEO title="Kontakta oss" description="Hör av dig till oss" keywords={[`Kontakta oss`]} />
     <section className="container">
       <h1>Kontakta oss</h1>
    <MyForm/> 

     </section>

    <br /><br /><br />
  </Layout2>
)

export default IndexPage
